import React from 'react'
import { Container, Panel, ToolBar, Button, Spacer } from '@sencha/ext-modern'

const Message = props => {
	const { onClose, text, subtext } = props
	return <Container fullScreen layout={{ type: 'vbox', align: 'center' }} padding={10}>
		<Panel ui="instructions" margin="30 0 10 0">
			<h2>{Tyan.t(text)}</h2>
			{subtext && <h3>{Tyan.t(subtext)}</h3>}
		</Panel>
		{onClose && <ToolBar defaults={{ margin: "0 10 0 0" }} docked='bottom' ui="app-transparent-toolbar" shadow={false} margin="0 0 0 10" padding="0" >
			<Spacer />
			<Button text='关闭' shadow ui='action' iconCls='x-fa fa-close' handler={onClose} />
			<Spacer />
		</ToolBar>}
	</Container>
}

export default Message